// 全局状态管理，具有全局性的状态可放入本store
import Storage from './storage';
import { Message } from 'hui-intl';
import Vue from 'vue';
import Cookie from 'js-cookie';
import getCookiesOption from '@pro/common/utils/getCookiesOption';
// import appmodeAssert from '@pro/common/mixins/appmodeAssert';

export const getIsMenuFixed = function () {
  const isMenuFixed = parseInt(localStorage.getItem('isMenuFixed'), 10);
  if (isMenuFixed === null || isMenuFixed === 1) {
    return true;
  } else if (isMenuFixed === 0) {
    return false;
  }
  return true;
};
export const getThirdCountryLastLoginMode = function () {
  return JSON.parse(localStorage.getItem('hik_connect_pro_LoginMode'));
};

const grayscaleFunctions = Storage.get(Storage.NAME.USER).grayscaleFunctions;
const getCookieDescribe = Storage.getObj(Storage.NAME.COOKIE_DESCRIBE)
  ? Storage.getObj(Storage.NAME.COOKIE_DESCRIBE).isChange
  : false;
const getCookieAgree = parseInt(Storage.realGet(Storage.NAME.ACCEPTED_COOKIE), 10) === 2;
export const store = Vue.observable({
  userParallerInfoVos: null,
  arcRedPointsInfo: {
    newArcList: [],
    diffNewArcList: [],
    redPointSiteId: 0
  },
  logStatus: 'icomoon-remote-log-toStart',
  supportCloudStorage: Array.isArray(grayscaleFunctions) ? grayscaleFunctions.includes(2) : false,
  touristMode: Storage.realGet(Storage.NAME.TOURIST_MODE) === 'true',
  squeezeWidth: 0,
  imageUrl: '',
  headerName: '',
  isMenuFixed: getIsMenuFixed(),
  showCompleteMenu: getIsMenuFixed(),
  canRenewMembership: true,
  sitePage: 1, // 站点详情回退时候回退到之前的分页页码
  siteTableCreateTime: 0, // 站点详情回退时候回退到之前的翻页情况
  preErrorCode: null,
  cookieHeight: 0,
  enableEventPush: true,
  enableDeviceLinkage: true,
  enableHealthCheck: true,
  dueTime: 0,
  memberType: 0,
  siteOpenType: 0, //进入站点详情的标记,
  oWebControl: null, //保存web控件,
  enablePrivileges: false,
  // 处于健康检测各状态的站点
  diagnosisStatus: {
    /**
         * key: siteId
         * value: {
                running: 0: normal; 1: checking; 2: checked,
                siteId: '',
                siteName: '',
                deviceStatus: {deviceSerial: true: checking; false: normal}
            }
         */
  },
  eventPushCapAbility: false,
  siteUpgradeProgress: '',
  upgradeState: 0,
  upgradeProgress: 0,
  upgradeStatus: 0,
  upgradeWebControl: null,
  lanUpgrade: null,
  isPreview: false,
  isPlayback: false,
  upgradeSite: '',
  upgradeType: 1,
  upgradeStartTime: 0,
  lanUpgradeParam: null,
  supportHCRLicensePay: false,
  upgradeControlLinkState: 2,
  paymentSupport: {
    online: false,
    license: false
  }, //仅工package管理页面使用，其他页面使用确保使用前有请求该数据
  isPromotion: false, // 仅保证在package管理页面有效
  deviceLimitForPackagePage: 1024,
  maintenanceAllExpired: false, // 仅供package管理使用
  employeeAllExpired: false, // 仅供package管理使用
  subscribeStatus: -1,
  hasShowSurvey: false,
  isOpenedPrice: false, //是否打开过价格单
  isNeedServicePoint: false, // Package Service的红点
  supportCloudStoragePayment: false,
  supportCloudStorageLicense: false,
  supportDevicePackages: false, // 设备运维包
  changeRoute: true,
  showFakeBreadcroumb: false, //假面包屑
  fakeBreadcroumb: {},
  resetDevicePasswordStartTimestamp: 0,
  resetDevicePasswordTimer: false,
  resetPasswordClose: false,
  supportAttendance: false, // 未认证情况下的Service Market红点
  thermonmetrySupport: false,
  PassengerFlowSupport: false,
  isNotAuthPoint: false, // 未认证情况下的Service Market红点
  isShowHccPoint: Storage.realGet(`entered-hcc${ Storage.get(Storage.NAME.USER).installerId}`) !== 'true',
  fromBatchConfigDeviceList: [],
  selectCountry: Storage.realGet(Storage.NAME.SELECT_COUNTRY), //选中的国家
  thirdCountryData: null, // 三方国家数据
  thirdCountryLastLoginMode: getThirdCountryLastLoginMode(), // 上次登录的三方国家及登录方式
  supportPriceList: false, //是否有价格单
  batchArmingGroupID: '', // 最新触发的批量布撤防分组的groupId
  batchArmingType: 0, // 最新触发的批量布撤防分组的类型，0撤防，1在家布防，2外出布防
  currentBatchArmingGroupList: [], // 当前账户触发的批量布撤防分组列表：包括groupId, status, ways
  deviceSerialJumpToSite: '', // 批量布撤防设备列表跳转到相应站点的设备序列号
  supportBatchArming: false, // 是否支持批量布撤防功能
  supportRemoteBatchConfig: false, // 是否支持远程批量配置功能
  vmsAbility: false, // 是否有vms使用权限
  simAbility: false, // 是否有sim卡管理权限
  giveCoBrandingPackage: true, //购买运维包是否赠送co-branding包
  giveEmployeePackage: true, //购买运维包是否赠送员工包
  getGivePackageFlag: false, //是否展示赠送弹窗
  setGivePackageInfo: null,
  getPromotionflag: 'noPromotion',
  needLanBatchPoint: !Storage.realGetByUser(Storage.USER_DATA_NAME.LAN_BATCH_CONFIG_RED_POINT),
  isCookieChange: getCookieDescribe, // web cookie 管理是否操作
  isCookieDisagree: getCookieAgree, // cookie 是否为全不接受
  supportPointSystem: false, // 支持积分系统
  todaySignedFlag: false, // 今日已签到
  pointsRules: [], // 积分规则
  pointType1Auth: true,
  pointType1Support: false,
  tokenData: {
    // token数据，包含托管（key：2）和非托管（key：0）
    /**
     * key: delegateState
     * value: {
     *      accessToken: "eafb8208849a87aeb3c03f7f4325eada0731d3dc98b6bfe7248ac3b8428d387440d5b8150163120120a0c776ec3fe64f16dd0a811e8eb100372c5f749ba65856b991c0e977baa84e5006135e0c106071",
     *      appKey: "583c2d550de0252d8cc7aaf0924b58f6655e851e82536034c05d77446bf522e6970260339ef7a4bcf9750a63c09dcf55",
     *      areaDomain: "https://isgpopen.ezvizlife.com",
     *      challenge: "e599043e20294ad8afb5b4294cbb6872",
     *      expireTime: 1618462920136,
     *      iterateNum: 100
     *  }
     */
  },
  sadpDeviceList: [],
  dialogIndex: -999, // 当前Home弹窗的判断顺序
  showVmsEndTip: true,
  globalTip: '',
  oneHikId: '', //onehikid登陆后返回
  supportSiteSharing: false, //支持站点分享
  HCCNeedGuide: false, //创建hcc系统未认证时需要引导认证
  supportHCRLicense: false,
  unReadMsg: {
    customer: 0,
    exception: 0,
    total: 0
  },
  canAuth: false, // 是否支持认证
  choosedIdentity: false, // 选择身份
  siteDeviceStatistics: null, // 当前站点设备信息
  hideTool: false,
  isFromHCC: false,
  nowupgradeDate: false,
  showCaseSupport: false,
  showRma: false,
  // 记录当前选择的tab
  tabKey: '',
  areaSupport: Storage.getObj(Storage.NAME.AREA_SUPPORT) || {}, // 国家或区域技术支持信息
  supportHCB: false,
  supportRemoteMaintenancePro: false,
  supportHealthMaintenance: false, // 开启新模式健康监测池功能
  ecoWebSocketInfo: [], // eco推送信息
  arcManagementSupport: false, //arc设备管理是否开启
  supportPersonalize: false, // 是否支持个性化推荐
  webCtlObj: null,
  webCtlLinkState: 0, // 控件连接状态 0 初始化、未连接  1 连接中 2 已连接 3 exe需要升级
  isFailedWbCtl: false, // 控件连接失败过
  webCtlUpdateStatus: null, // 控件更新状态
  localDeviceList: [], // sadp数据
  needRebootDevice: [], // 局域网升级需要重启数据
  upgradingDevices: [], // 局域网升级正在升级数据
  forceUpdateModule: {}, // 强制更新是否更新
  companyInfo: {}, //公司信息
  questionnaireArray: [], //问卷
  epSupportAgentService: false, // ep客服智能体能力
  epAgentUrl: '', // ep客服智能体地址
  webCtlUpdateInfo: {}, // 控件更新数据
  arcMessageSupport: false, //arc消息是否开启
  EpPromise: null,
  tutorialPageListInfo: {},
  twoFAFlag: null,
  timeZone: null
});

export const mutations = {
  setUserParallerInfoVos(userParallerInfoVos) {
    store.userParallerInfoVos = userParallerInfoVos;
  },
  setAreaSupport(areaSupport) {
    // 只有数据是数组，并且长度大于0时才做处理，否则没有必要处理
    if (!(Array.isArray(areaSupport) && areaSupport.length > 0)) {
      return;
    }
    // type: 0-邮箱，1-电话。排序规则：邮箱排在电话前面
    areaSupport.sort((a, b) => a.type - b.type);
    store.areaSupport = areaSupport.reduce(
      (obj, item) => {
        if (item.type === 0) {
          obj.email.push(item.content);
        } else if (item.type === 1) {
          obj.phone.push(item.content);
        }
        return obj;
      },
      {
        email: [],
        phone: []
      }
    );
    // 将国家或区域技术支持信息写入缓存，在接口中没有获取到数据时，作为默认值
    Storage.setObj(Storage.NAME.AREA_SUPPORT, store.areaSupport);
  },
  setSupportPersonalize(value) {
    store.supportPersonalize = value;
  },
  setArcRedPointsInfo(arcRedPointsInfo) {
    store.arcRedPointsInfo = arcRedPointsInfo;
  },
  setLogStatus(flag) {
    store.logStatus = flag;
  },
  setVmsAbility(flag) {
    store.vmsAbility = flag;
    Storage.realSetByUser('vmsAbility', flag);
  },
  setSimAbility(flag) {
    store.simAbility = flag;
    Storage.realSetByUser('simAbility', flag);
  },
  setThirdCountryData(state) {
    store.thirdCountryData = state;
  },
  setThirdCountryLastLoginMode(state) {
    store.thirdCountryLastLoginMode = state;
    localStorage.setItem('hik_connect_pro_LoginMode', JSON.stringify(state));
  },
  setFakeBreadcrumb({ texts }) {
    store.fakeBreadcroumb = texts ? { texts } : {};
  },
  setFakeBreadcrumbShow(show) {
    store.showFakeBreadcroumb = show;
  },
  setChangeRoute(change) {
    store.changeRoute = change;
  },
  setlanUpgradeParam(params) {
    store.lanUpgradeParam = params;
  },
  setUpgradeControlLinkState(state) {
    store.upgradeControlLinkState = state;
  },
  setUpgradeStartTime(time) {
    store.upgradeStartTime = time;
  },
  setUpgradeType(type) {
    store.upgradeType = type;
  },
  setSupportRma(value) {
    store.showRma = value;
  },
  setUpgradeSite(siteId) {
    store.upgradeSite = siteId;
  },
  setUpgradeWebControl(webcontrol) {
    store.upgradeWebControl = webcontrol;
  },
  setLanUpgrade(webcontrol) {
    store.lanUpgrade = webcontrol;
  },
  setEnablePrivileges(enable) {
    store.enablePrivileges = enable;
  },
  setUpgradeProgress(progress) {
    store.upgradeProgress = progress;
  },
  setUpgradeStatus(statu) {
    store.upgradeStatus = statu;
  },
  setTouristMode(isTouristMode) {
    store.touristMode = isTouristMode;
    Storage.realSet(Storage.NAME.TOURIST_MODE, isTouristMode);
  },
  setSelectCountry(index) {
    store.selectCountry = index;
    Storage.realSet(Storage.NAME.SELECT_COUNTRY, index);
  },
  setSiteOpenType(openType) {
    store.siteOpenType = openType;
  },
  setWebControl(webControl) {
    store.oWebControl = webControl;
  },
  setMemberType(memberType) {
    store.memberType = memberType;
  },
  setDueTime(dueTime) {
    store.dueTime = dueTime;
  },
  setSqueezeWidth(width) {
    store.squeezeWidth = width;
  },
  setImageUrl(url) {
    store.imageUrl = url;
  },
  setHeaderName(name) {
    store.headerName = name;
  },
  setMenuFixedStatus(isFixed) {
    store.isMenuFixed = isFixed;
    localStorage.setItem('isMenuFixed', isFixed ? 1 : 0);
  },
  setShowCompleteMenu(isShow) {
    store.showCompleteMenu = isShow;
  },
  setSitePage(page) {
    store.sitePage = page;
  },
  setPreErrorCode(code) {
    store.preErrorCode = code;
  },
  setSiteTableCreatTime(time) {
    store.siteTableCreateTime = time;
  },
  setCookieHeight(height) {
    store.cookieHeight = height;
  },
  setEnableEventPush() {
    store.enableEventPush = true;
  },
  setEnableDeviceLinkage() {
    store.enableDeviceLinkage = true;
  },
  setEnableHealthCheck() {
    store.enableHealthCheck = true;
  },
  // 设置站点检测信息
  setDiagnosisStatus(status) {
    store.diagnosisStatus = Object.assign({}, store.diagnosisStatus, {
      [status.siteId]: status
    });
  },
  // 删除站点检测信息
  deleteDiagnosisStatus(siteId) {
    delete store.diagnosisStatus[siteId];
    store.diagnosisStatus = Object.assign({}, store.diagnosisStatus);
  },
  setPreviewStatus(status) {
    store.isPreview = status;
  },
  setPlaybackStatus(status) {
    store.isPlayback = status;
  },
  setSubscribeStatus(status) {
    store.subscribeStatus = status;
  },
  setHasShowSurvey(status) {
    store.hasShowSurvey = status;
  },
  setPaymentSupport(status) {
    store.paymentSupport = status;
  },
  setPackagePromotionFlag(flag) {
    store.isPromotion = flag;
  },
  setDeviceLimitForPackagePage(number) {
    store.deviceLimitForPackagePage = number;
  },
  setMaintenanceAllExpired(flag) {
    store.maintenanceAllExpired = flag;
  },
  setEmployeeAllExpired(flag) {
    store.employeeAllExpired = flag;
  },
  setCloudStorage(flag) {
    store.supportCloudStorage = flag;
  },
  setOpenedPrice(flag) {
    store.isOpenedPrice = flag;
  },
  setNeedServicePoint(flag) {
    store.isNeedServicePoint = flag;
  },
  setCloudStoragePaymentAbility(flag) {
    store.supportCloudStoragePayment = flag;
  },
  setCloudStorageLicenseAbility(flag) {
    store.supportCloudStorageLicense = flag;
  },
  setDevicePackages(flag) {
    store.supportDevicePackages = flag;
  },
  setResetDevicePasswordStartTimestamp(indexcode) {
    store.resetDevicePasswordStartTimestamp = indexcode;
  },
  setResetDevicePasswordTimer(flag) {
    store.resetDevicePasswordTimer = flag;
  },
  setNotAuthPoint(flag) {
    store.isNotAuthPoint = flag;
  },
  setHccPoint(flag) {
    store.isShowHccPoint = flag;
  },
  setAttendanceAbility(flag) {
    store.supportAttendance = flag;
  },
  setFromBatchConfigDeviceList(array) {
    store.fromBatchConfigDeviceList = _.cloneDeep(array);
  },
  setPriceList(flag) {
    store.supportPriceList = flag;
  },
  setBatchArmingStatus(obj = {}) {
    store.batchArmingGroupID = obj.id || '';
    if (obj.controlType === 0) {
      store.batchArmingType = obj.ways === 0 ? 1 : 2;
    } else {
      store.batchArmingType = 0;
    }
  },
  setSupportBatchArming(flag) {
    store.supportBatchArming = flag; // 重启灰度控制，控制美国
  },
  setSupportRemoteBatchConfig(flag) {
    store.supportRemoteBatchConfig = flag;
  },
  setCurrentBatchArmingGroupList(list) {
    store.currentBatchArmingGroupList = list;
  },
  setDeviceSerialJumpToSite(deviceSerial) {
    store.deviceSerialJumpToSite = deviceSerial;
  },
  setGiveCoBrandingPackageFlag(flag) {
    store.giveCoBrandingPackage = flag;
  },
  setGiveEmployeePackageFlag(flag) {
    store.giveEmployeePackage = flag;
  },
  setGivePackageFlag(flag, data) {
    store.getGivePackageFlag = flag;
    store.setGivePackageInfo = data;
  },
  setPromotionflag(status) {
    store.getPromotionflag = status;
  },
  setNeedLanBatchPoint(flag) {
    store.needLanBatchPoint = flag;
  },
  setIsCookieChange(status) {
    store.isCookieChange = status;
  },
  setIsCookieDisagree(status) {
    store.isCookieDisagree = status;
  },
  setSupportPointSystem(status) {
    // 支持积分
    store.supportPointSystem = status;
    Storage.realSetByUser('supportPointSystem', status);
  },
  setPointsRules(pointsRulesList) {
    store.pointsRules = pointsRulesList;
    pointsRulesList.forEach((rule) => {
      if (rule.pointType === 1 && rule.rules && rule.rules.length) {
        if (rule.rules[0].point !== 0) {
          store.pointType1Support = true;
        }
      }
      if (rule.pointType === 100 && rule.rules && rule.rules.length) {
        if (rule.rules[0].installerAuthFlag === false) {
          store.pointType1Auth = false;
        }
      }
    });
  },
  setTodaySignedFlag(todaySignedFlag) {
    store.todaySignedFlag = todaySignedFlag;
  },
  setTokenData(key, value) {
    store.tokenData[key] = value;
  },
  setSadpDeviceList(device) {
    const index = store.sadpDeviceList.findIndex((item) => {
      return item.deviceSerial === device.deviceSerial;
    });
    if (-1 === index) {
      store.sadpDeviceList.push(device);
    } else {
      store.sadpDeviceList.splice(index, 1, device);
    }
  },
  setDialogIndex(index) {
    store.dialogIndex = index;
  },
  setShowVmsEndTip(value) {
    store.showVmsEndTip = value;
  },
  setOnehikId(val) {
    store.oneHikId = val;
  },
  setSupportSiteSharing(value) {
    store.supportSiteSharing = value;
  },
  setHCCNeedGuide(value) {
    store.HCCNeedGuide = value;
  },
  setSupportHCROnlinePay(value) {
    // 0只显示 Online Purchase
    // 1只显示 Purchase bu Service Key
    // 2都显示
    store.supportHCROnlinePay = value;
  },
  setSupportHCRLicensePay(value) {
    store.supportHCRLicensePay = value;
  },
  setThermonmetrySupport(value) {
    store.thermonmetrySupport = value;
  },
  SetPassengerFlowSupport(value) {
    store.PassengerFlowSupport = value;
  },
  setUnReadMsg(value) {
    store.unReadMsg = value;
  },
  setCanAuth(value) {
    store.canAuth = value;
  },
  setChooseIdentity(value) {
    store.choosedIdentity = value;
  },
  setSiteDeviceStatistics(value) {
    store.siteDeviceStatistics = value;
  },
  setHideTool(value) {
    store.hideTool = value;
  },
  setIsFromHCC(value) {
    //来着HCC的注册（完善信息时使用）
    store.isFromHCC = value;
  },
  setNowupgradeDate(value) {
    store.nowupgradeDate = value;
  },
  setCaseSupport(value) {
    store.showCaseSupport = value;
    Cookie.set('email', Storage.get(Storage.NAME.USER).email, getCookiesOption());
  },
  setTabKey(value) {
    store.tabKey = value;
  },
  setSupportHCB(value) {
    store.supportHCB = value;
  },
  setSupportRemoteMaintenancePro(value) {
    store.supportRemoteMaintenancePro = value;
  },
  setSupportHealthMaintenance(value) {
    store.supportHealthMaintenance = value;
  },
  setEcoWebSocketInfo(value) {
    store.ecoWebSocketInfo = value;
  },
  setArcManagementSupport(value) {
    store.arcManagementSupport = value;
  },
  setArcMessageSupport(value) {
    store.arcMessageSupport = value;
  },
  setWebCtlFailedStatus(value) {
    store.isFailedWbCtl = value;
  },
  setWebCtlLinkState(value) {
    store.webCtlLinkState = value;
  },
  setWebCtlObj(value) {
    store.webCtlObj = value;
  },
  setWebCtlUpdateStatus(obj) {
    store.webCtlUpdateStatus = obj;
  },
  setWebCtlUpdateInfo(key, obj) {
    store.webCtlUpdateInfo[key] = obj;
  },
  setLocalDeviceList(list) {
    store.localDeviceList = list;
  },
  setNeedRebootDevice(list) {
    store.needRebootDevice = list;
  },
  setUpgradingDevices(list) {
    store.upgradingDevices = list;
  },
  setForceUpdateModule(obj) {
    store.forceUpdateModule = obj;
  },
  setCompanyInfo(value) {
    store.companyInfo = value;
  },
  setQuestionnaireArray(value = []) {
    store.questionnaireArray = value;
  },
  setEpAgentSupport(value, url) {
    store.epSupportAgentService = value;
    if (value) {
      store.epAgentUrl = url;
    }
  },
  setTimezone(value) {
    store.timeZone = value;
  },
  setResetPasswordClose(value) {
    store.resetPasswordClose = value;
  },
  setEpPromise(promise) {
    store.EpPromise = promise;
  },
  setTutorialPageListInfo(val = {}) {
    store.tutorialPageListInfo = val;
  },
  set2FAFlag(val) {
    store.twoFAFlag = val;
  }
};

export const resetStore = function () {
  store.squeezeWidth = 0;
  store.imageUrl = '';
  store.headerName = '';
  store.isMenuFixed = getIsMenuFixed();
  store.showCompleteMenu = getIsMenuFixed();
  store.sitePage = 1;
  store.siteTableCreateTime = 0;
  // store.cookieHeight = 0;
  store.enableEventPush = true;
  store.enableHealthCheck = true;
  store.enableDeviceLinkage = true;
  store.diagnosisStatus = {};
  store.isPreview = false;
  store.subscribeStatus = -1;
  //清除消息弹框
  if (store.hasShowSurvey) {
    store.hasShowSurvey = false;
    Message.closeAll();
  }
  store.paymentSupport = '';
  store.isPromotion = false;
  store.deviceLimitForPackagePage = 1024;
  store.supportCloudStorage = false;
  store.isOpenedPrice = false;
  store.isNeedServicePoint = false;
  store.supportCloudStoragePayment = false;
  store.supportCloudStorageLicense = false;
  store.supportDevicePackages = false;
  store.isNotAuthPoint = false;
  store.supportAttendance = false;
  store.thermonmetrySupport = false;
  store.PassengerFlowSupport = false;
  store.supportPriceList = false;
  store.maintenanceAllExpired = false;
  store.employeeAllExpired = false;
  store.batchArmingGroupID = '';
  store.supportBatchArming = false;
  store.supportRemoteBatchConfig = false;
  store.vmsAbility = false;
  store.simAbility = false;
  store.giveCoBrandingPackage = true;
  store.giveEmployeePackage = true;
  store.isCookieChange = getCookieDescribe;
  store.supportPointSystem = false;
  store.pointType1Support = false;
  store.pointsRules = [];
  store.pointType1Auth = true;
  store.tokenData = {};
  store.dialogIndex = -999;
  store.oneHikId = '';
  store.supportSiteSharing = false;
  store.supportPersonalize = false;
  store.HCCNeedGuide = false;
  store.supportHCROnlinePay = false;
  store.supportHCRLicensePay = false;
  store.unReadMsg = {
    customer: 0,
    exception: 0,
    total: 0
  };
  store.canAuth = false;
  store.choosedIdentity = false;
  store.siteDeviceStatistics = null;
  store.hideTool = false;
  store.isFromHCC = false;
  store.showCaseSupport = false;
  store.showRma = false;
  store.supportHCB = false;
  Storage.realRemoveByUser('supportPointSystem');
  store.supportRemoteMaintenancePro = false;
  store.supportHealthMaintenance = false;
  store.ecoWebSocketInfo = [];
  store.arcManagementSupport = false;
  store.webCtlObj = null;
  store.webCtlLinkState = 0;
  store.isFailedWbCtl = false;
  store.webCtlUpdateStatus = null;
  store.localDeviceList = [];
  store.forceUpdateModule = null;
  store.companyInfo = {};
  store.questionnaireArray = [];
  store.epSupportAgentService = false;
  store.epAgentUrl = '';
  store.webCtlUpdateInfo = {};
  store.needRebootDevice = [];
  store.upgradingDevices = [];
  store.arcManagementSupport = false;
  store.EpPromise = null;
  store.tutorialPageListInfo = {};
  store.twoFAFlag = false;
  store.timeZone = null;
};
